import { z } from 'zod';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { useMaxCharacters } from './useMaxCharacters';

export function useRequiredString() {
    const { t } = useServerTranslation();
    const maxCharacters = useMaxCharacters();

    return (message: string, max?: number) => {
        const min_object = z.string({
            required_error: t(message),
            invalid_type_error: t(message),
        }).min(1, { message: t(message) });

        return maxCharacters(min_object, max);
    };
}
